import { render, staticRenderFns } from "./damages.vue?vue&type=template&id=6367ce2a&"
import script from "./damages.vue?vue&type=script&lang=js&"
export * from "./damages.vue?vue&type=script&lang=js&"
import style0 from "./damages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports